import React from "react";
import { Link } from "react-router-dom";
import TriangularUp from "../assets/triangular/triangular-bg-demo-up.svg";
import TriangularDown from "../assets/triangular/triangular-bg-demo-down.svg";
import "./Demo.css";

function Demo() {
    return (
        <div>
            <img
                src={TriangularUp}
                alt="background grey triangular"
                className="triangular-bg-demo"
            />
            <section className="demo">
                <div className="demo-container">
                    <div className="demo-content">
                        <h2>
                            Finally, a solution that works at scale without any manual processes
                        </h2>
                        <p>
                            Give stakeholders everything they need to make better decisions faster.
                        </p>
                    </div>
                    <a href="/schedule-demo">
                        <span>Schedule demo</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M16.7803 11.4697C17.0732 11.7626 17.0732 12.2374 16.7803 12.5303L9.28033 20.0303C8.98744 20.3232 8.51256 20.3232 8.21967 20.0303C7.92678 19.7374 7.92678 19.2626 8.21967 18.9697L15.1893 12L8.21967 5.03033C7.92678 4.73744 7.92678 4.26256 8.21967 3.96967C8.51256 3.67678 8.98744 3.67678 9.28033 3.96967L16.7803 11.4697Z"
                                fill="white"
                            />
                        </svg>
                    </a>
                </div>
            </section>
            <img
                src={TriangularDown}
                alt="background grey triangular"
                className="triangular-bg-demo"
            />
        </div>
    );
}

export default Demo;
